import { useContext } from 'react'

import { Image, ModalContext, SidebarModal } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useDefaultQuoteItem from '@hooks/useDefaultQuoteItem'

import CustomItemImageUrl from './assets/custom-item.svg'
import OrderItemImageUrl from './assets/order-item.svg'

const MODAL_KEY = 'NewDefaultQuoteItemModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const NewDefaultQuoteItemModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { defaultQuoteItem: initDefaultQuoteItem } = modalPayload

  const defaultQuoteItemPayload = useDefaultQuoteItem(initDefaultQuoteItem)
  const {
    callbacks: {
      addOrderableDefaultQuoteItem,
      createOrEditDefaultQuoteItem,
    },
  } = defaultQuoteItemPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Add" titleSecondLine="Default Item" />

      <SidebarModal.Content hasFooter={false}>
        <SidebarModal.Button
          iconLeft={<Image backgroundSize="contain" height={30} width={30} url={CustomItemImageUrl} />}
          onClick={() => createOrEditDefaultQuoteItem()}
          showAngleIcon
          subtitle="Customise your item to set as default"
          title="Custom Item"
        />

        <SidebarModal.Button
          iconLeft={<Image backgroundSize="contain" height={30} width={30} url={OrderItemImageUrl} />}
          onClick={() => addOrderableDefaultQuoteItem()}
          showAngleIcon
          subtitle="Select from predefined list of items"
          title="Orderable Item"
        />
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <NewDefaultQuoteItemModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
